import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

type UnpublishTemplateModalProps = {
  isOpen: boolean;
  close: () => void;
  onUnpublish: () => void;
  isLoading?: boolean;
};

export const UnpublishTemplateModal = ({
  isOpen,
  close,
  onUnpublish,
  isLoading = false,
}: UnpublishTemplateModalProps) => (
  <Modal.Root open={isOpen} onOpenChange={close}>
    <Modal.Content size="small">
      <StatusModal type="danger" title="Unpublish current checklist?">
        The customer will no longer be able to access this checklist while
        it&apos;s unpublished. You&apos;ll need to publish it again for the
        checklist to become visible to them.
      </StatusModal>
      <Modal.FooterButtonGroup>
        <Modal.RawClose asChild>
          <Button type="button" disabled={isLoading}>
            Cancel
          </Button>
        </Modal.RawClose>
        <Button
          type="button"
          customType="danger"
          isLoading={isLoading}
          disabled={isLoading}
          onClick={onUnpublish}
        >
          Unpublish
        </Button>
      </Modal.FooterButtonGroup>
    </Modal.Content>
  </Modal.Root>
);
